import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_GET_UPDATE_LEAVE,
} from "../../RollCallConfig/RollCallConfig";
import PropTypes from "prop-types";
import { Select, Spin } from "antd";

const UpdateEmpLeave = ({ updateObj }) => {
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [comments, setComments] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [updateObjData, setUpdateObjData] = useState([]);
  const [status, setStatus] = useState();

  useEffect(() => {
    if (updateObj?.status) {
      setStatus(updateObj.status);
    }
  }, [updateObj]);

  const navigate = useNavigate();
  console.log(status);

  const badgeMap = {
    CT: { color: "primary", label: "Casual" },
    PL: { color: "success", label: "Personal" },
    SL: { color: "danger", label: "Sick" },
    OD: { color: "warning", label: "On Duty" },
    WO: { color: "info", label: "Week Off" },
    OL: { color: "secondary", label: "Optional" },
    CO: { color: "dark", label: "Comp Off" },
    EL: { color: "primary", label: "Earned" },
    HL: { color: "light", label: "Holiday" },
  };

  const badge = badgeMap[updateObj?.LvCode] || {
    color: "dark",
    label: "Unknown",
  };

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  useEffect(() => {
    if (updateObj) {
      setUpdateObjData(updateObj);
    }
  }, [updateObj]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");

    if (token) {
      setTokenData(token);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const handleSubmit = () => {
    setLoadingBtn(true);

    const payload = {
      status: status,
      leaveid: updateObj?.Id,
      regid: regId,
      comments: comments,
    };
    console.log(JSON.stringify(payload));
    fetch(`${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_UPDATE_LEAVE}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenData}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response data:", data);

        if (data.status === true) {
          Swal.fire({
            title: "Success!",
            text: "Your leave request has been saved.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "There was an issue saving your leave request. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        console.error("Error saving leave:", error);
        Swal.fire({
          title: "Error!",
          text: "There was an error while submitting the request. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoadingBtn(false);
      });
  };

  const resetStates = () => {
    setComments("");
  };

  useEffect(() => {
    const offcanvasElement = document.getElementById(
      "offcanvasRightUpdateLeave"
    );

    if (offcanvasElement) {
      const onOffcanvasHidden = () => {
        resetStates();
      };

      offcanvasElement.addEventListener(
        "hidden.bs.offcanvas",
        onOffcanvasHidden
      );

      // Cleanup event listener on component unmount
      return () => {
        offcanvasElement.removeEventListener(
          "hidden.bs.offcanvas",
          onOffcanvasHidden
        );
      };
    }
  }, []);

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightUpdateLeave {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightUpdateLeave {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightUpdateLeave {
            width: 35% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightUpdateLeave {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightUpdateLeave {
            width:17% !important;
          }
        }
        `}
      </style>
      {loadingBtn && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="offcanvas offcanvas-end" id="offcanvasRightUpdateLeave">
        <div className="offcanvas-header">
          <h4>Update Leave</h4>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-4 mb-3">
                <h5 className="fw-bold text-gray">{updateObjData?.UserName}</h5>
              </div>
              <div className="col-4 mb-3">
                <label className="form-label me-2 ">Type:</label>
                <span className={`badge bg-${badge.color}`}>{badge.label}</span>
              </div>
              <div className="col-3 mb-3">
                <label className="form-label me-2">Duration: </label>
                <span className="badge bg-success">
                  {updateObj?.LeaveCount}
                </span>
              </div>

              <div className="col-6 mb-3">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={updateObj?.StartDt?.split("T")[0]}
                  disabled
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={updateObj?.EndDt?.split("T")[0]}
                  disabled
                />
              </div>

              <div className="col-5 mb-3">
                <label className="form-label">
                  <span className="text-danger ms-1">*</span>Status
                </label>
                <Select
                  value={status}
                  style={{ width: 120 }}
                  onChange={(value) => setStatus(value)}
                >
                  <Select.Option value={1}>Pending</Select.Option>
                  <Select.Option value={2}>Approved</Select.Option>
                  <Select.Option value={3}>Rejected</Select.Option>
                </Select>
              </div>

              <div className="col-12 mb-3">
                <label className="form-label">Reason</label>
                <textarea
                  className="form-control"
                  value={updateObj?.Comments}
                  disabled
                />
              </div>
              <div className="col-12">
                <label className="form-label">Comments</label>
                <textarea
                  className="form-control"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                  placeholder="Enter Comments"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-secondary me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={loadingBtn}
                onClick={handleSubmit}
              >
                {loadingBtn ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

UpdateEmpLeave.propTypes = {
  updateObj: PropTypes.object.isRequired,
};

export default UpdateEmpLeave;
